import { TipoIdentificacionId } from "@shared/Entities/Usuario/identificacionId.entity";

export class NuevoUsuarioAdminCorporativo{
    email: string;
    nombres: string;
    apellidos: string;
    telefono: string;
    identificacion: string;
    tipoIdentificacionId: TipoIdentificacionId;
    empresas: EmpresaNuevoUsuarioAdminCorporativo[] = [];
}

export class EmpresaNuevoUsuarioAdminCorporativo{
    nombre: string;
    rnc: string;
    cuentas: CuentaNuevoUsuarioAdminCorporativo[];
}

export class CuentaNuevoUsuarioAdminCorporativo{
    nombre: string;
    codigo: string;
    afiFondoId: number;
    numero: string;
    afiFondoNombre: string;
    afiCuentasAfiPermisos:CuentasAfiPermisoNuevoUsuarioAdminCorporativo[];
}

export class CuentasAfiPermisoNuevoUsuarioAdminCorporativo{
    afiPermisoId: number;
    afiPermisoNombre: string;
}
